import { combineReducers } from 'redux';
import appReducer, { AppState } from './appReducer';
import globalReducer, { GlobalConfigState } from './globalConfigReducer';
import formConfigReducer, { IFormConfigState } from './formConfigReducer';
import termsConfigFormReducer, { ITermsConfigState } from './termsConfigReducer';
import formSessionReducer, { IFormSessionState } from './formSessionReducer';
import formElementsReducer, { IFormElementsState } from './formElementsReducer';
import userReducer, { IUserState } from './userReducer';

export interface RootStore {
  app: AppState;
  globalConfig: GlobalConfigState;
  formConfig: IFormConfigState;
  formElements: IFormElementsState;
  termsConfig: ITermsConfigState;
  formSession: IFormSessionState;
  userState: IUserState;
}

const reducers = {
  app: appReducer,
  globalConfig: globalReducer,
  formConfig: formConfigReducer,
  formElements: formElementsReducer,
  termsConfig: termsConfigFormReducer,
  formSession: formSessionReducer,
  userState: userReducer,
};

const rootReducer = combineReducers(reducers);
export default rootReducer;
